<template>
    <div :class="fullClassList">
        {{ copy }}
    </div>
</template>

<script>
    export default {
        name: 'BannerEl',
        props: {
            classList: {
                type: Array,
                default() {
                    return [];
                }
            },
            copy: {
                type: String
            }
        },
        computed: {
            fullClassList: function () {
                return ['banner'].concat(this.classList).join(' ');
            }
        }
    };
</script>
